import { useQuery } from '@tanstack/react-query';

import { defaultImportTaxSettings } from '@/services/tax/defaults';
import { importTaxSettingsQuery } from '@/services/tax/queries';
import { type ImportTaxSettings } from '@/services/tax/types';

/**
 * The figures behind the calculators. If they cannot be read, the built-in
 * copy is used so the page still works — `isFallback` says so, and the page
 * shows the date the built-in figures came from.
 */
export function useImportTaxSettings(): {
  settings: ImportTaxSettings;
  isPending: boolean;
  isFallback: boolean;
} {
  const query = useQuery(importTaxSettingsQuery());
  return {
    settings: query.data ?? defaultImportTaxSettings,
    isPending: query.isPending,
    isFallback: !query.data,
  };
}
